angular.module('tasks')
    .component('taskAuditLogsList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/task/audit-log/audit-logs-list.html',
        controller: function (TaskService, TaskAuditService) {
            this.TaskService = TaskService;
            this.TaskAuditService = TaskAuditService;
            this.actions = ['CREATED', 'UPDATED', 'DELETED'];
            this.reset = () => this.filters = {};
        }
    });
